import { Divider } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { NextStepButton, PreviousStepButton, SaveButtonsGroup } from '../../containers/save-buttons/SaveButtonsGroup';
import ContentConstants from '../../contentConstants';
import { AudienceSourceType } from '../../models';
import { IApplicationState } from '../../store';
import { ActionCreators as AudienceListActionCreators } from '../../store/AudienceListStore';
import { SendEmailModal } from '../audience/email/SendEmailModal';
import { CardLayout } from '../common';
import { SurveyNoteHeaderContainer } from '../notes/SurveyNoteHeaderContainer';
import { AddAudienceButton } from './AddAudienceButton';
import { AudienceCopyModal } from './AudienceCopyModal';
import { AudienceMode } from './AudienceMode';
import { AudienceWarningModal } from './AudienceWarningModal';
import { NoAudience } from './NoAudience';
import { NoAudienceSource } from './NoAudienceSource';
import { AudienceTable } from './table/AudienceTable';

const hiddenContainerStyle = {
	width: '0',
	opacity: 0,
	overflow: 'hidden',
	height: '0',
};

const AddAudienceButtonContainer = styled.div`
	margin-bottom: 20px;
	text-align: right;
`;

export const AudienceList = () => {
	const dispatch = useDispatch();
	const { sendEmailModalOpen, pendingSendEmailAudience, audienceDeleteInProgress, audiences, loading } = useSelector(
		(state: IApplicationState) => state.audienceList,
	);
	const { audienceSourceType, surveyId } = useSelector((state: IApplicationState) => state.survey.surveyEditModel.survey);
	const { isLoading } = useSelector((state: IApplicationState) => state.survey);
	const isAudienceLoading = isLoading || loading;

	return (
		<CardLayout loading={isAudienceLoading} title={ContentConstants.STEPPER_STEP_DISTRIBUTION} header={<SurveyNoteHeaderContainer />}>
			<div style={loading ? hiddenContainerStyle : undefined}>
				{getPrimaryContent()}
				<Divider type='dashed' />
				<SaveButtonsGroup>
					<PreviousStepButton />
					<NextStepButton />
				</SaveButtonsGroup>

				<AudienceWarningModal />
				<AudienceCopyModal mode={AudienceMode.Edit} />
				{sendEmailModalOpen && (
					<SendEmailModal
						modalOpen={sendEmailModalOpen}
						surveyId={pendingSendEmailAudience?.surveyId}
						audienceId={pendingSendEmailAudience?.audienceId}
						shouldReplaceSurveyLink={false}
						closeModal={() => dispatch(AudienceListActionCreators.ToggleSendEmailModal(false))}
					/>
				)}
			</div>
		</CardLayout>
	);

	function getPrimaryContent() {
		if (audienceSourceType !== undefined) {
			if (audiences.length === 0) {
				return <NoAudience surveyId={surveyId} />;
			} else {
				return (
					<>
						{audienceSourceType !== AudienceSourceType.Hierarchy && (
							<AddAudienceButtonContainer>
								<AddAudienceButton surveyId={surveyId} mode={AudienceMode.Edit} dropdownPositionX={-186} dropdownPositionY={40} />
							</AddAudienceButtonContainer>
						)}
						<AudienceTable
							surveyId={surveyId}
							audiences={audiences}
							audienceDeleteInProgress={audienceDeleteInProgress}
							audienceSourceType={audienceSourceType}
							mode={AudienceMode.Edit}
						/>
					</>
				);
			}
		} else {
			return <NoAudienceSource />;
		}
	}
};
